export default __webpack_public_path__ + "static/media/01.be1ebb47.jpg";